import React from "react";
import { Title, Card, Accordion, Paragraph } from "@sicredi/react";

import "./index.scss";

export const DPOsList: React.FC = () => {
  return (
    <section className="dpo-list-section">
      <Title className="dpo-list-title" as="h2">
        Lei Geral de Proteção de Dados (LGPD)
      </Title>
      <Card className="dpo-card">
        <Accordion aria-label="Lista de DPOS" className="dpo-list-accordion">
          <Accordion.Item label="Encarregado - DPO">
            <Paragraph className="paragraph">
              Se você tiver dúvidas ou quiser se comunicar com o Sicredi a
              respeito das informações presentes nesta Política, contate o
              Encarregado responsável pela sua cooperativa acessando a lista
              abaixo.
            </Paragraph>
            <Paragraph className="paragraph">
              <a
                className="highlight-green"
                href="https://web-static.sicredi.io/lgpd-politica-privacidade-lib@1/pdf/media_produtos_filer_public_2025_05_09_dpo-0905.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Clique aqui para acessar a lista dos DPOs.
              </a>
            </Paragraph>
          </Accordion.Item>
        </Accordion>
      </Card>
    </section>
  );
};

export default DPOsList;
